<template>
  <div class="lphero">
    <div class="lphero__content">
      <h4 class="lphero__title">
        Continue where you left off - {{ learningPath.name }}
      </h4>
      <h2 v-if="course" class="lphero__name">{{ course.name }}</h2>
      <div class="lphero__actions">
        <div class="lphero__progress">
          <div class="lphero__progress-copy-wrapper">
            <h5 class="lphero__progress-copy--percentage">
              {{ progressPercentage }}% Complete
            </h5>
            <span class="lphero__separator">|</span>
            <div v-if="hasNextUpContent" class="lphero__progress-copy">
              Next up:
              <ActionLoader
                v-if="isLoading"
                loaderClass="lphero__nextup-loader"
                :size="0.5"
              />
              <span v-else class="lphero__nextup">
                {{ nextUpProperties.type }} - {{ nextUpProperties.name }}</span
              >
            </div>
          </div>
        </div>
        <div class="lphero__cta-wrapper">
          <button
            v-if="course"
            class="btn btn--primary"
            @click="handleResumeContent"
          >
            <PlayIcon />
            Resume Course
          </button>
          <router-link :to="$buildContentLink('path', learningPath)">
            <button class="lphero__explore-lp lphero__link btn btn--secondary">
              Explore {{ learningPath.name }}
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionLoader from '@/components/shared/ActionLoader.vue'
import PlayIcon from '@/assets/icons/fill/play.svg'

export default {
  name: 'ResumeFromLearningPath',
  components: {
    ActionLoader,
    PlayIcon: { ...PlayIcon, name: 'PlayIcon' },
  },
  props: {
    learningPath: {
      type: Object,
      required: true,
    },
    course: {
      type: Object,
      required: true,
    },
    learningArea: {
      type: String,
      required: true,
    },
    instructor: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    hasNextUpContent: {
      type: Boolean,
      required: true,
    },
    nextUpProperties: {
      type: Object,
      required: true,
    },
    courseLinkProperties: {
      type: Object,
      required: true,
    },
  },
  computed: {
    progressPercentage() {
      const { progress } = this.course
      return progress && progress > 0 ? Math.floor(progress * 100) : 0
    },
  },
  methods: {
    handleResumeContent() {
      this.$emit('resume-content')
    },
  },
}
</script>

<style></style>
